<div class="time-slots-date-item">
  <span>{{ timeSlot().date | uiTodayTomorrowDate: 'EEEE' }} от {{ cheapestOption()?.price?.total }} ₽</span>

  <span>
    {{ timeSlot().date | date: 'd MMMM' }}
  </span>
</div>
